import {FC, useEffect, useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';

type Props = {
  title: string
  message: string
  type: string
  redirect: string
}

const ModelPopup: FC<Props> = ({title, message, type, redirect}) => {
  const [openClass, setOpenClass] = useState('hide')
  let navigate = useNavigate();
  useEffect(() => {
    if(message !== ""){
      document.body.classList.add('modal-open')
      setOpenClass('show')
    }
    return () => {
      document.body.classList.remove('modal-open')
      setOpenClass('hide')
    }
  }, [message])

  const closePopup = () => {
    return navigate(redirect)
  }

  return (
    <>
      <div
        className={`modal fade ${openClass} d-block`}
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      > 
        <div className={`alert bg-light-${type} modal-content modal-dialog mw-500px rounded d-flex flex-center flex-column py-5 px-5 px-lg-5 mb-10`}>
          <button type="button" className={`position-absolute top-0 end-0 m-2 btn btn-icon btn-icon-${type}`} onClick={() => closePopup()}>
            <span className="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px"><rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect><rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect></svg>
            </span>
          </button>

          <span className={`svg-icon svg-icon-5tx svg-icon-${type} mb-5`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px"><path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path><path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path></svg>
          </span>

          <div className="text-center">
            <h5 className="fw-bolder fs-1 mb-5">{title}</h5>

            <div className="separator separator-dashed border-danger opacity-25 mb-5"></div>

            <div className="mb-9 fs-4">
             {message}
            </div>
            {redirect !== "" && 
              <div className="d-flex flex-center flex-wrap">
                <Link to={`${redirect}`} className={`btn btn-${type} m-2`}>
                  Okay
                </Link>
              </div>
            }
          </div>
        </div>

        {/* <div className='modal-dialog modal-dialog-centered mw-750px'>
          <div className='modal-content'>
            <div className='modal-header pt-4 pb-4'>
              <h2 className='fw-bolder textColor'>Update Profile Details</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                // onClick={() => setItemIdForUpdate(undefined)}
                style={{cursor: 'pointer'}}
              >
                <KTSVG path='/img/arr061.svg' className='svg-icon-1' />
              </div>
            </div>
            <div className='modal-body scroll-y mx-4 mx-xl-4 my-2'>
            </div>
          </div>
        </div> */}
      </div>
      <div className={`modal-backdrop fade ${openClass}`}></div>
    </>
  )
}

export {ModelPopup}
